const useDefaultMinLengthNegativeFieldError = () => {
  return (minNegative: number) => ({
    validator: (_: unknown, value: number) => {
      if (value === undefined || value >= minNegative) {
        return Promise.resolve();
      }
      return Promise.reject(
        new Error(`O valor negativo não pode ser menor que ${minNegative}`),
      );
    },
  });
};

export default useDefaultMinLengthNegativeFieldError;
